import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import CampaignService from "services/Campaign";

const DeleteCampaignStatusModal = ({
  campaignStatus,
  open,
  onOpenChange,
  fetchStatuses,
}) => {
  const handleConfirm = async () => {
    try {
      await CampaignService.deleteCampaignStatus(campaignStatus.id);
      toast.success("Campaign status deleted");
      onOpenChange(false);
      await fetchStatuses();
    } catch {
      toast.error("Failed to delete campaign status");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete campaign status?"
      description="Are you sure you want to delete this Campaign Status?"
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteCampaignStatusModal;
